import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-spanish-course',
    templateUrl: './spanish-course.component.html',
    styleUrls: ['./spanish-course.component.scss'],
    standalone: false
})
export class SpanishCourseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
